var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.nodesData,"highlight-current":true,"node-key":"id"},on:{"node-click":_vm.handleNodeClicked},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
return _c('div',{staticClass:"el-tree-node__label his-information-item-type-selector",class:node.data.iconClass},[_vm._v("\n      "+_vm._s(node.label)+"\n    ")])}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }